<div class="access-denied">
    <h1>Access Denied</h1>
    <p>You do not have permission to access this page.</p>
    <button (click)="fnBackToHome()" class="btn btn-primary">Go to Home</button>
</div>